import {FieldModeEnum} from '../../../../service/company/company-type';

import * as styles from './tag-mode.scss';

export const TAG_CLASS_NAME_BY_FIELD_MODE: Record<FieldModeEnum, string> = {
    [FieldModeEnum.addition]: styles.addition,
    [FieldModeEnum.replacement]: styles.replacement,
};
